/**
 @ngdoc directive
 @name candidatePaymentDetails

 @description
 Loads candidate specific payment details allowing candidate to add / edit / remove payment details

 @usage
 <candidate-payment-details></candidate-payment-details>

 @param {search-term}  json data                       - Individual search term data

 */

(function() {
    'use strict';
    var candidatePaymentDetails = function ($templateCache, $http, ajaxCall, xmsNotificationFactory, i18nService) {
        return {
            restrict: 'E',
            replace: true,
            transclude: true,
            controllerAs: "ctrl",
            scope: true,
            template: $templateCache.get('components/candidatePaymentDetails.html'),
            controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

                var _this = this;

                this.$onInit = function(){

                    // Listing out the payment types (avoiding magic numbers)
                    _this.LOOKUP_VALUES = {
                        PAYE_ID: 43,
                        PSC_ID: 44,
                        UMBRELLA_ID: 45
                    };

                    // Listing request links
                    _this.organisationDetailsUrl = WEBAPP_PATH + "/payment/getCandidateOrgs";
                    _this.paymentDetailsUrl = WEBAPP_PATH + "/payment/getPaymentMethods";
                    _this.endedPaymentDetailsUrl = WEBAPP_PATH + "/payment/getEndedPaymentMethods";
                    _this.paymentTypePermissionsUrl = WEBAPP_PATH + "/payment/getPaymentTypePermissions";
                    _this.deletePaymentUrl = WEBAPP_PATH + "/payment/deleteCandidatePaymentType";
                    _this.updatePaymentUrl = WEBAPP_PATH + "/payment/updatePaymentMethod";
                    _this.savePaymentUrl = WEBAPP_PATH + "/payment/savePaymentMethod";

                    _this.states = {};

                    // Initiation functions
                    getOrganisationDetails();
                    getPaymentTypePermissions();

                    // get i18n messages
                    _this.i18nService = i18nService.preLoadI18nValues({
                        'default.candidatePaymentDetails.sortCode.tooltip': 'Please enter sort code in the following format: No hyphens, digits only e.g. 123456',
                        'bankDetail.sortCode.label': 'Sort Code',
                        'taxStatus.header.label' : 'Tax Statuses Explained',
                        'taxStatus.paye.description' : 'Please select PAYE if you will be working and being paid directly by Reed',
                        'taxStatus.umbrella.description' : 'Please select Umbrella if you will be working and being paid through an Umbrella company',
                        'taxStatus.psc.description' : 'Please select PSC if you will be working and being paid through your own Limited company',
                        'taxStatus.returningCand.description' : 'Please click ‘Edit Payment Details’ below to amend your existing payment details or alternatively select a different tax status from the dropdown.'

                    });
                };

                /**
                 * Payment editing function
                 * @param payTypeId
                 */
                $scope.editPaymentDetails = function(payTypeId){
                    resetData();
                    $scope.formModel.states.editing = true;
                    _this.states.payTypeId = payTypeId;
                    $scope.formModel.tempPaymentDetails = angular.copy($scope.formModel.paymentDetails);
                    getPaymentDetails();
                };

                /**
                 * Cancel payment editing function
                 */
                $scope.cancelEditing = function(){
                    $scope.formModel.states.editing = false;
                    _this.states.payTypeId = null;
                    $scope.formModel.paymentDetails = $scope.formModel.tempPaymentDetails;
                    getPaymentDetails();
                };

                /**
                 * Updating candidate ID based on organisation view selected
                 */
                $scope.updateCandidateId = function(){
                    _this.candidateId = $scope.formModel.candidateId;
                    resetData();
                };

                /**
                 * Helping function to hide or show existing payment methods from Add Payment Details list
                 * @param payTypeId
                 * @returns {boolean}
                 */
                $scope.checkIfMethodExists = function(payTypeId){
                    for (var k in _this.paymentDetails){
                        if(_this.paymentDetails[k].payTypeId == payTypeId){
                            return true;
                        }
                    }
                    return false;
                };

                /**
                 * Helping function to show or hide the Add Payment Details section
                 * @returns {number}
                 */
                $scope.getNumberOfMissingPaymentMethods = function(){
                    let numberOfMissingPaymentMethods = (_this.states.permissions.paymentMethods.length) - (_this.paymentDetails.length);
                    return numberOfMissingPaymentMethods;
                };

                /**
                 * Function to get empty payment details to layout adding payment details forms
                 * @param paymentType
                 */
                $scope.getEmptyFormFields = function(paymentType){
                    if(paymentType){
                        /**
                         * Emptying form values
                         */
                        if($scope.formModel.paymentDetails[paymentType]){
                            $scope.formModel.paymentDetails[paymentType] = {};
                        }
                        getEmptyPaymentDetails();
                    }else{
                        resetData();
                    }
                };

                /**
                 * Payment detail saving function
                 * @param paymentDetails
                 * @param payTypeId
                 * @param makeDefault
                 */
                $scope.saveOrUpdatePaymentDetail = function(paymentDetails, payTypeId, makeDefault, isUpdate){
                    saveOrUpdatePaymentDetail(paymentDetails, payTypeId, makeDefault, isUpdate);
                };

                /**
                 * Payment detail deletion function
                 * @param payment
                 */
                $scope.deletePaymentDetail = function(payment){
                    const id = payment.id;
                    const candId = _this.candidateId;
                    deletePaymentDetail(id, candId);
                };

                /**
                 * Cancel adding payment details function
                 */
                $scope.cancelAddingPaymentDetails = function(){
                    resetData();
                };

                /**
                 * Helping function to help with min length validation parameter
                 * @param validationType
                 * @returns {*}
                 */
                $scope.getMinLength = function(validationType){
                    let minLength;
                    if (validationType == 'accountNo'){
                        minLength = 8;
                    }else if(validationType == 'sortCode'){
                        minLength = 6;
                    }
                    return minLength;
                };

                /**
                 * Helping function that helpls with maxlength parameter for validation
                 * @param validationType
                 * @returns {*}
                 */
                $scope.getMaxLength = function(validationType){
                    let maxLength;
                    if (validationType == 'accountNo'){
                        maxLength = 8;
                    }else if(validationType == 'sortCode'){
                        maxLength = 8;
                    }else if(validationType == 'bicNumber'){
                        maxLength = 11;
                    }else if(validationType == 'ibanNumber'){
                        maxLength = 22;
                    }else if(validationType == 'buildingSocietyRollNo'){
                        maxLength = 18;
                    }
                    return maxLength;
                };

                /**
                 * Returns a Regex pattern allowing only numbers if the label is equal to 'sort code'
                 * @param label
                 * @returns {string}
                 */
                 $scope.getPattern = function(label){
                     return (label == _this.i18nService.message('bankDetail.sortCode.label', 'Sort Code') || label == _this.i18nService.message('taxStatusDetail.vatRegNo.label', 'Vat Reg No')) ? "[0-9]+" : ""
                };

                /**
                 * Helping function that helps with required parameter for validation
                 * @param validationType
                 * @returns {boolean}
                 */
                $scope.isRequired = function (validationType){
                    let required = false;
                    if (validationType == 'isRequired' || validationType == 'accountNo' || validationType == 'sortCode' || validationType == 'bicNumber' || validationType == 'ibanNumber'){
                        required = true;
                    }
                    return required;
                };

                /**
                 * Function that will set post code validation pattern and message based on country ID
                 * @param countryId
                 */
                $scope.setPostCodePattern = function (countryId) {
                    $scope.postCodePattern = {};
                    const countryCodeIreland =  794;
                    if (countryId == countryCodeIreland) {
                        $scope.postCodePattern.code = /^[0-9]*$/;
                        $scope.postCodePattern.message = 'Field value can only be numbers.';
                    }else {
                        $scope.postCodePattern.code = /^[a-zA-Z0-9]{1}(.)*$/;
                        $scope.postCodePattern.message = 'Field value can only start with number or letter.';
                    }
                };

                /**
                 * Payment saving function that sends a Post method request
                 * @param paymentDetails
                 * @param payTypeId
                 * @param makeDefault
                 */
                function saveOrUpdatePaymentDetail(paymentDetails, payTypeId, makeDefault, isUpdate){

                    if($scope.primary.$valid){
                        if(makeDefault){
                            paymentDetails['bankDetail.isDefault'] = true;
                        }

                        _this.ajaxInProgress = true;
                        _this.ajaxState = 'IN_PROGRESS';

                        let url = _this.savePaymentUrl;

                        if(isUpdate){
                            url = _this.updatePaymentUrl;
                        }


                        paymentDetails.candId = parseInt($scope.formModel.candidateId, 10);
                        paymentDetails.taxStatusTypeLookupValId = payTypeId;

                        let data = paymentDetails;

                        $.ajax({
                            method: "POST",
                            url: url,
                            data: data
                        }).then(function successCallback(result) {
                            xmsNotificationFactory.addObj({id: "savePayment", type: result.type, bodyHtml: result.message, timeout:5});
                            _this.ajaxState = 'COMPLETED_SUCCESS';
                            _this.ajaxInProgress = false;
                            resetData();
                        }, function errorCallback(result) {
                            xmsNotificationFactory.addObj({id: "savePayment", type: result.type, bodyHtml: result.message, timeout:5});
                            _this.ajaxState = 'COMPLETED_FAILED';
                            _this.ajaxInProgress = false;
                            resetData();
                        });
                    }else{
                        if ($scope.primary.$invalid) {
                            angular.forEach($scope.primary.$error, function (field) {
                                angular.forEach(field, function(errorField){
                                    errorField.$setTouched();
                                })
                            });
                        }
                    }
                }

                /**
                 * Delete payment details function
                 * @param id
                 * @param candId
                 */
                function deletePaymentDetail(id, candId){
                    _this.ajaxInProgress = true;
                    _this.ajaxState = 'IN_PROGRESS';

                    const url = _this.deletePaymentUrl;
                    $.ajax({
                        method: "POST",
                        url: url,
                        data: {
                            id: id,
                            candId: candId
                        }
                    }).then(function successCallback(result) {
                        xmsNotificationFactory.addObj({id: "deletePayment", type: result.type, bodyHtml: result.message, timeout:5});
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                        resetData();
                    }, function errorCallback(result) {
                        xmsNotificationFactory.addObj({id: "deletePayment", type: result.type, bodyHtml: result.message, timeout:5});
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                        resetData();
                    });
                }

                /**
                 * Function that resets the state as well as updates to the most recent data
                 */
                function resetData(){
                    getPaymentDetails();
                    $scope.formModel.states.editing = false;
                    _this.emptyPaymentDetails = null;
                    $scope.formModel.paymentDetails = null;
                }

                /**
                 * Get organisation details function
                 */
                function getOrganisationDetails(){
                    _this.ajaxInProgress = true;
                    _this.ajaxState = 'IN_PROGRESS';

                    let url = _this.organisationDetailsUrl;

                    $http({
                        method: 'GET',
                        url: url
                    }).then(function successCallback(result) {
                        _this.organisationDetails = result.data;
                        _this.candidateId = result.data[0].candidateId;
                        _this.bankValidation = result.data[0].bankValidation;
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                        getPaymentDetails();
                    }, function errorCallback(result) {
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                        getPaymentDetails();
                    });
                }

                /**
                 * Get empty payment details function
                 */
                function getEmptyPaymentDetails(){
                    _this.ajaxInProgress = true;
                    _this.ajaxState = 'IN_PROGRESS';

                    let url = _this.paymentDetailsUrl;

                    $http({
                        method: 'GET',
                        url: url
                    }).then(function successCallback(result) {
                        _this.emptyPaymentDetails = result.data;
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                    }, function errorCallback(result) {
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                    });
                }

                /**
                 * Get payment details function
                 */
                function getPaymentDetails(){
                    _this.ajaxInProgress = true;
                    _this.ajaxState = 'IN_PROGRESS';

                    let url = _this.paymentDetailsUrl + '?candId=' + _this.candidateId;

                    $http({
                        method: 'GET',
                        url: url
                    }).then(function successCallback(result) {
                        _this.paymentDetails = result.data;
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                    }, function errorCallback(result) {
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                    });

                    getEndedPaymentDetails();
                }

                /**
                 * Get ended payment details function
                 */
                function getEndedPaymentDetails(){
                    _this.ajaxInProgress = true;
                    _this.ajaxState = 'IN_PROGRESS';

                    let url = _this.endedPaymentDetailsUrl + '?candId=' + _this.candidateId;

                    $http({
                        method: 'GET',
                        url: url
                    }).then(function successCallback(result) {
                        _this.endedPaymentDetails = result.data;
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                    }, function errorCallback(result) {
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                    });
                }

                /**
                 * Get permissions function that also lists payment types
                 */
                function getPaymentTypePermissions(){
                    _this.ajaxInProgress = true;
                    _this.ajaxState = 'IN_PROGRESS';

                    $http({
                        method: 'GET',
                        url: _this.paymentTypePermissionsUrl
                    }).then(function successCallback(result) {
                        _this.states.permissions = result.data;
                        _this.ajaxState = 'COMPLETED_SUCCESS';
                        _this.ajaxInProgress = false;
                    }, function errorCallback(response) {
                        _this.ajaxState = 'COMPLETED_FAILED';
                        _this.ajaxInProgress = false;
                    });
                }
            }]
        };
    };

    candidatePaymentDetails.$inject = ['$templateCache', '$http', 'ajaxCall', 'xmsNotificationFactory', 'i18nService'];
    angular.module('app').directive('candidatePaymentDetails', candidatePaymentDetails);

}());
